export default __webpack_public_path__ + "static/media/Group 427319028.78621b60.png";